import { useState, useCallback, useEffect } from "react";

let logoutTimer;

const useAuth = () => {
  const [name, setName] = useState("نوید");
  const [type, setType] = useState("lab");
  const [tokenExpirationDate, setTokenExpirationDate] = useState();
  const [token, setToken] = useState(false);

  const login = useCallback((token, type, name, expirationDate) => {
    setToken(token);
    setType(type);
    setName(name);
    const tokenExpirationDate =
      expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60 * 24);
    setTokenExpirationDate(tokenExpirationDate);
    localStorage.setItem(
      "userData",
      JSON.stringify({
        token: token,
        expiration: tokenExpirationDate.toISOString(),
        name: name,
        type: type,
      }),
    );
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setTokenExpirationDate(null);
    setType(null);
    setName(null);
    localStorage.removeItem("userData");
  }, []);

  useEffect(() => {
    if (token && tokenExpirationDate) {
      const remainingTime =
        tokenExpirationDate.getTime() - new Date().getTime();
      logoutTimer = setTimeout(logout, remainingTime);
    } else {
      clearTimeout(logoutTimer);
    }
  }, [token, logout, tokenExpirationDate]);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("userData"));
    if (
      storedData &&
      storedData.token &&
      new Date(storedData.expiration) > new Date()
    ) {
      login(
        storedData.token,
        storedData.type,
        storedData.name,
        new Date(storedData.expiration),
      );
    }
  }, [login]);

  return {
    token,
    login,
    type,
    name,
    logout,
  };
};

export default useAuth;
